import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Close = ({ className }) => {
  return (
    <svg
      viewBox="0 0 17 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames("icon", "icon-close", { [className]: className })}
    >
      <rect x="3.14844" y="9.63623" width="16" height="2" transform="rotate(45 3.14844 9.63623)" fill="#F0F3FF" />
      <rect x="1.73438" y="20.9497" width="16" height="2" transform="rotate(-45 1.73438 20.9497)" fill="#F0F3FF" />
    </svg>
  );
};

Close.propTypes = {
  className: PropTypes.string,
};

export default Close;
